import { ThemeProvider } from 'styled-components/macro'
import { colors } from 'utils/styles/colors'

export const RootThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return <ThemeProvider theme={{ colors, notTouchScreen }}>{children}</ThemeProvider>
}

export const notTouchScreen = '@media (hover), (min--moz-device-pixel-ratio: 0)' as const
